export interface LMSRecord {
  month: number;
  L: number;
  M: number;
  S: number;
}

export const whoWeightLMS: { male: LMSRecord[]; female: LMSRecord[] } = {
  male: [
    { month: 0, L: 0.3487, M: 3.3464, S: 0.14602 },
    { month: 1, L: 0.2297, M: 4.4709, S: 0.13395 },
    { month: 2, L: 0.1970, M: 5.5675, S: 0.12385 },
    { month: 3, L: 0.1738, M: 6.3762, S: 0.11727 },
    { month: 4, L: 0.1553, M: 7.0023, S: 0.11316 },
    { month: 5, L: 0.1395, M: 7.5105, S: 0.11080 },
    { month: 6, L: 0.1257, M: 7.9340, S: 0.10958 },
    { month: 7, L: 0.1134, M: 8.2970, S: 0.10902 },
    { month: 8, L: 0.1021, M: 8.6151, S: 0.10882 },
    { month: 9, L: 0.0917, M: 8.9014, S: 0.10881 },
    { month: 10, L: 0.0820, M: 9.1649, S: 0.10891 },
    { month: 11, L: 0.0730, M: 9.4122, S: 0.10906 },
    { month: 12, L: 0.0644, M: 9.6479, S: 0.10925 },
    { month: 13, L: 0.0563, M: 9.8749, S: 0.10949 },
    { month: 14, L: 0.0487, M: 10.0953, S: 0.10976 },
    { month: 15, L: 0.0413, M: 10.3108, S: 0.11007 },
    { month: 16, L: 0.0343, M: 10.5228, S: 0.11041 },
    { month: 17, L: 0.0275, M: 10.7319, S: 0.11079 },
    { month: 18, L: 0.0211, M: 10.9385, S: 0.11119 },
    { month: 19, L: 0.0148, M: 11.1430, S: 0.11164 },
    { month: 20, L: 0.0087, M: 11.3462, S: 0.11211 },
    { month: 21, L: 0.0029, M: 11.5486, S: 0.11261 },
    { month: 22, L: -0.0028, M: 11.7504, S: 0.11314 },
    { month: 23, L: -0.0083, M: 11.9514, S: 0.11369 },
    { month: 24, L: -0.0137, M: 12.1515, S: 0.11426 },
    { month: 25, L: -0.0189, M: 12.3502, S: 0.11485 },
    { month: 26, L: -0.0240, M: 12.5466, S: 0.11544 },
    { month: 27, L: -0.0289, M: 12.7401, S: 0.11604 },
    { month: 28, L: -0.0337, M: 12.9303, S: 0.11664 },
    { month: 29, L: -0.0385, M: 13.1169, S: 0.11723 },
    { month: 30, L: -0.0431, M: 13.3000, S: 0.11781 },
    { month: 31, L: -0.0476, M: 13.4798, S: 0.11839 },
    { month: 32, L: -0.0520, M: 13.6567, S: 0.11896 },
    { month: 33, L: -0.0564, M: 13.8309, S: 0.11953 },
    { month: 34, L: -0.0606, M: 14.0031, S: 0.12008 },
    { month: 35, L: -0.0648, M: 14.1736, S: 0.12062 },
    { month: 36, L: -0.0689, M: 14.3429, S: 0.12116 },
    { month: 37, L: -0.0729, M: 14.5113, S: 0.12168 },
    { month: 38, L: -0.0769, M: 14.6791, S: 0.12220 },
    { month: 39, L: -0.0808, M: 14.8466, S: 0.12271 },
    { month: 40, L: -0.0846, M: 15.0140, S: 0.12322 },
    { month: 41, L: -0.0883, M: 15.1813, S: 0.12373 },
    { month: 42, L: -0.0920, M: 15.3486, S: 0.12425 },
    { month: 43, L: -0.0957, M: 15.5158, S: 0.12478 },
    { month: 44, L: -0.0993, M: 15.6828, S: 0.12531 },
    { month: 45, L: -0.1028, M: 15.8497, S: 0.12586 },
    { month: 46, L: -0.1063, M: 16.0163, S: 0.12643 },
    { month: 47, L: -0.1097, M: 16.1827, S: 0.12700 },
    { month: 48, L: -0.1131, M: 16.3489, S: 0.12759 },
    { month: 49, L: -0.1165, M: 16.5150, S: 0.12819 },
    { month: 50, L: -0.1198, M: 16.6811, S: 0.12880 },
    { month: 51, L: -0.1230, M: 16.8471, S: 0.12943 },
    { month: 52, L: -0.1262, M: 17.0132, S: 0.13005 },
    { month: 53, L: -0.1294, M: 17.1792, S: 0.13069 },
    { month: 54, L: -0.1325, M: 17.3452, S: 0.13133 },
    { month: 55, L: -0.1356, M: 17.5111, S: 0.13197 },
    { month: 56, L: -0.1387, M: 17.6768, S: 0.13261 },
    { month: 57, L: -0.1417, M: 17.8422, S: 0.13325 },
    { month: 58, L: -0.1447, M: 18.0073, S: 0.13389 },
    { month: 59, L: -0.1477, M: 18.1722, S: 0.13453 },
    { month: 60, L: -0.1506, M: 18.3366, S: 0.13517 },
  ],
  female: [
    { month: 0, L: 0.3809, M: 3.2322, S: 0.14171 },
    { month: 1, L: 0.1714, M: 4.1873, S: 0.13724 },
    { month: 2, L: 0.0962, M: 5.1282, S: 0.13000 },
    { month: 3, L: 0.0402, M: 5.8458, S: 0.12619 },
    { month: 4, L: -0.0050, M: 6.4237, S: 0.12402 },
    { month: 5, L: -0.0430, M: 6.8985, S: 0.12274 },
    { month: 6, L: -0.0756, M: 7.2970, S: 0.12204 },
    { month: 7, L: -0.1039, M: 7.6422, S: 0.12178 },
    { month: 8, L: -0.1288, M: 7.9487, S: 0.12181 },
    { month: 9, L: -0.1507, M: 8.2254, S: 0.12199 },
    { month: 10, L: -0.1700, M: 8.4800, S: 0.12223 },
    { month: 11, L: -0.1872, M: 8.7192, S: 0.12247 },
    { month: 12, L: -0.2024, M: 8.9481, S: 0.12268 },
    { month: 13, L: -0.2158, M: 9.1699, S: 0.12283 },
    { month: 14, L: -0.2278, M: 9.3870, S: 0.12294 },
    { month: 15, L: -0.2384, M: 9.6008, S: 0.12299 },
    { month: 16, L: -0.2478, M: 9.8124, S: 0.12303 },
    { month: 17, L: -0.2562, M: 10.0226, S: 0.12306 },
    { month: 18, L: -0.2637, M: 10.2315, S: 0.12309 },
    { month: 19, L: -0.2703, M: 10.4393, S: 0.12315 },
    { month: 20, L: -0.2762, M: 10.6464, S: 0.12323 },
    { month: 21, L: -0.2815, M: 10.8534, S: 0.12335 },
    { month: 22, L: -0.2862, M: 11.0608, S: 0.12350 },
    { month: 23, L: -0.2903, M: 11.2688, S: 0.12369 },
    { month: 24, L: -0.2941, M: 11.4775, S: 0.12390 },
    { month: 25, L: -0.2975, M: 11.6864, S: 0.12414 },
    { month: 26, L: -0.3005, M: 11.8947, S: 0.12441 },
    { month: 27, L: -0.3032, M: 12.1015, S: 0.12472 },
    { month: 28, L: -0.3057, M: 12.3059, S: 0.12506 },
    { month: 29, L: -0.3080, M: 12.5073, S: 0.12545 },
    { month: 30, L: -0.3101, M: 12.7055, S: 0.12587 },
    { month: 31, L: -0.3120, M: 12.9006, S: 0.12633 },
    { month: 32, L: -0.3138, M: 13.0930, S: 0.12683 },
    { month: 33, L: -0.3155, M: 13.2837, S: 0.12737 },
    { month: 34, L: -0.3171, M: 13.4731, S: 0.12794 },
    { month: 35, L: -0.3186, M: 13.6618, S: 0.12855 },
    { month: 36, L: -0.3201, M: 13.8503, S: 0.12919 },
    { month: 37, L: -0.3216, M: 14.0385, S: 0.12988 },
    { month: 38, L: -0.3230, M: 14.2265, S: 0.13059 },
    { month: 39, L: -0.3243, M: 14.4140, S: 0.13135 },
    { month: 40, L: -0.3257, M: 14.6010, S: 0.13213 },
    { month: 41, L: -0.3270, M: 14.7873, S: 0.13293 },
    { month: 42, L: -0.3283, M: 14.9727, S: 0.13376 },
    { month: 43, L: -0.3296, M: 15.1573, S: 0.13460 },
    { month: 44, L: -0.3309, M: 15.3410, S: 0.13545 },
    { month: 45, L: -0.3322, M: 15.5240, S: 0.13630 },
    { month: 46, L: -0.3335, M: 15.7064, S: 0.13716 },
    { month: 47, L: -0.3348, M: 15.8882, S: 0.13800 },
    { month: 48, L: -0.3361, M: 16.0697, S: 0.13884 },
    { month: 49, L: -0.3374, M: 16.2511, S: 0.13968 },
    { month: 50, L: -0.3387, M: 16.4322, S: 0.14051 },
    { month: 51, L: -0.3400, M: 16.6133, S: 0.14132 },
    { month: 52, L: -0.3414, M: 16.7942, S: 0.14213 },
    { month: 53, L: -0.3427, M: 16.9748, S: 0.14293 },
    { month: 54, L: -0.3440, M: 17.1551, S: 0.14371 },
    { month: 55, L: -0.3453, M: 17.3347, S: 0.14448 },
    { month: 56, L: -0.3466, M: 17.5136, S: 0.14525 },
    { month: 57, L: -0.3479, M: 17.6916, S: 0.14600 },
    { month: 58, L: -0.3492, M: 17.8686, S: 0.14675 },
    { month: 59, L: -0.3505, M: 18.0445, S: 0.14748 },
    { month: 60, L: -0.3518, M: 18.2193, S: 0.14821 },
  ],
};
